<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page @page:afterin="afterin" @page:beforeout="beforeOut">
    <template v-if="questionId && question">
      <f7-navbar :title="`選項編輯: ${question.title}`" back-link="back">
        <f7-nav-right>
          <f7-link @click="onDeleteQuestion({ questionId, index: currentElementPath[elementLevel].index, elementLevel })">
            <font-awesome-icon icon="trash" />
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <element-path :path="currentElementPath" />
      <f7-list style="margin: 0px 0px 0px 0px;">
        <f7-list-item inline-label ref="title">
          <f7-label>選項:</f7-label>
          <f7-input type="text" :value="question.title" @input="updateProperties('title', $event.target.value)" @focus="onFocus('title')" clear-button />
        </f7-list-item>
        <f7-list-item
          :title="`選項種類  : ${$t(`questionType.${question.type}`)}`"
          :link="`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/questions/${questionId}/change-question-type-actions`">
          <font-awesome-icon slot="after" icon="edit" style="color: #4CAF50; margin-right: 10px;" />
        </f7-list-item>
      </f7-list>
      <component
        :is="toEditor(question.type)"
        :storeId="storeIdProp"
        :menuDraftVariation="menuDraftVariationProp"
        :categoryId="categoryId"
        :groupId="groupId"
        :itemId="itemId"
        :questionId="questionId"
        :pathLength="pathLength" />
    </template>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RadioEditor from '@/components/draft-question-editors/RadioEditor'
import SwitchEditor from '@/components/draft-question-editors/SwitchEditor'
import NumberEditor from '@/components/draft-question-editors/NumberEditor'
import CheckboxEditor from '@/components/draft-question-editors/CheckboxEditor'
import NumberGroupEditor from '@/components/draft-question-editors/NumberGroupEditor'
import ElementPath from '@/components/ElementPath'
import * as R from 'ramda'

export default {
  dependencies: ['questionType'],
  data () {
    return {
      pathLength: 0
    }
  },
  created () {
    this.pathLength = this.currentElementPath.length
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    categoryId () { return this.currentElementPath[0].id },
    groupId () { return this.currentElementPath[1].id },
    itemId () { return this.currentElementPath[2].id },
    elementLevel () { return this.pathLength === 6 ? 5 : 3 },
    questionId () { return this.currentElementPath[this.elementLevel] ? this.currentElementPath[this.elementLevel].id : null },
    question () { return this.currentDraft.questions[this.questionId] }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'setQuestionProperties', 'deleteQuestion', 'setOptionProperties']),
    updateProperties (prop, v) {
      this.setQuestionProperties({ questionId: this.question.id, elementLevel: this.elementLevel, properties: R.assoc(prop, v, {}) })
    },
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    onDeleteQuestion ({ questionId, index, elementLevel }) {
      this.$f7.dialog.confirm(`確定要刪除 ${this.question.title} ?`, '刪除選項', () => {
        this.deleteQuestion({ questionId, index, elementLevel })
        this.$f7router.back()
      })
    },
    toEditor (type) {
      return type.charAt(0).toUpperCase() + type.slice(1) + 'Editor'
    },
    afterin () {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.pathLength))
    },
    beforeOut () {
      this.$f7.dialog.close()
    }
  },
  components: {
    RadioEditor,
    SwitchEditor,
    NumberEditor,
    CheckboxEditor,
    NumberGroupEditor,
    ElementPath
  }
}
</script>
